import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PageError from '../error/pageError';
import PersonalSpacesList from '../widgets/personal_spaces/list/list';
import { ManagerContextProvider } from '../manager/components/context';
export default class PersonalSpaceOrganization extends React.Component {
    render() {
        const { path, organization } = this.props;

        return (
            <ManagerContextProvider>
                <Switch>
                    <Route exact path={`${path}/`} render={() => <PersonalSpacesList organization={organization} />} />
                    {/* Error */}
                    <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
                </Switch>
            </ManagerContextProvider>
        );
    }
}

PersonalSpaceOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
